export default "/assets/images/mila-feed-13.mp4?73c0b3a3ecf63d236d390d30ae4506eb";